@if (loading) {
  <p class="patient-home__state">{{ 'COMMON.LOADING' | translate }}</p>
} @else {
  <section class="patient-home">
    <div class="patient-home__cards">
      <article class="patient-home__card">
        <span>{{ 'PATIENT_SPACE.COUNTERS.CLINICS' | translate }}</span>
        <strong>{{ data?.counters?.clinics || 0 }}</strong>
      </article>
      <article class="patient-home__card">
        <span>{{ 'PATIENT_SPACE.COUNTERS.UPCOMING' | translate }}</span>
        <strong>{{ data?.counters?.upcoming || 0 }}</strong>
      </article>
      <article class="patient-home__card">
        <span>{{ 'PATIENT_SPACE.COUNTERS.PENDING' | translate }}</span>
        <strong>{{ data?.counters?.pending_requests || 0 }}</strong>
      </article>
      <article class="patient-home__card">
        <span>{{ 'PATIENT_SPACE.COUNTERS.PROPOSALS' | translate }}</span>
        <strong>{{ data?.counters?.proposals || 0 }}</strong>
      </article>
    </div>

    <section class="patient-home__section">
      <h3>{{ 'PATIENT_SPACE.SECTIONS.UPCOMING' | translate }}</h3>
      <div class="patient-home__empty" *ngIf="!(data?.upcomingAppointments?.length)">
        {{ 'PATIENT_SPACE.EMPTY.UPCOMING' | translate }}
      </div>
      <article class="patient-home__row" *ngFor="let item of data?.upcomingAppointments; trackBy: trackById">
        <div>
          <strong>{{ item?.site?.name || '-' }}</strong>
          <p>{{ item?.start | date: 'dd/MM/yyyy HH:mm' }}</p>
        </div>
        <span>{{ item?.treatments?.[0] || item?.description || '-' }}</span>
      </article>
    </section>

    <section class="patient-home__section">
      <h3>{{ 'PATIENT_SPACE.SECTIONS.PROPOSALS' | translate }}</h3>
      <div class="patient-home__empty" *ngIf="!(data?.counterProposals?.length)">
        {{ 'PATIENT_SPACE.EMPTY.PROPOSALS' | translate }}
      </div>
      <article class="patient-home__row" *ngFor="let item of data?.counterProposals; trackBy: trackById">
        <div>
          <strong>{{ item?.site?.name || '-' }}</strong>
          <p>{{ item?.counter_proposal?.start | date: 'dd/MM/yyyy HH:mm' }} - {{ item?.counter_proposal?.end | date: 'HH:mm' }}</p>
        </div>
        <span>{{ item?.counter_proposal?.comment || ('PATIENT_SPACE.NO_COMMENT' | translate) }}</span>
      </article>
    </section>
  </section>
}
